import React from "react";
import { renderUsersActions, renderNewUsersModalActions } from "./customRenderers";
import { renderEditableInput, renderEditableBoolean } from "../../../constants/reactUtilities";
import FilterUtility from "../../common/FilterUtility";
export const usersDataColumns = (
  onChangeMethod,
  isEditable,
  deleteUser,
  changePassword,
  canChangePassword
) => {
  return [
    {
      Header: "ITS",
      id: "its",
      accessor: "its",
      Cell: renderEditableInput.bind(this, "users.data.$.", "its", isEditable, onChangeMethod, "text"),
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="text" />
    },
    {
      Header: "Name",
      id: "name",
      accessor: "name",
      Cell: renderEditableInput.bind(this, "users.data.$.", "name", isEditable, onChangeMethod, "text"),
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="text" />
    },

    {
      Header: "Email",
      id: "email",
      accessor: "email",
      Cell: renderEditableInput.bind(this, "users.data.$.", "email", isEditable, onChangeMethod, "text"),
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="text" />
    },
    {
      Header: "Position",
      id: "position",
      accessor: "position",
      Cell: renderEditableInput.bind(this, "users.data.$.", "position", isEditable, onChangeMethod, "text"),
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="text" />
    },
    {
      Header: "Is Active",
      id: "is_active",
      accessor: "is_active",
      Cell: renderEditableBoolean.bind(this, "users.data.$.", "is_active", isEditable, onChangeMethod),
      style: { textAlign: "center" },
      filterable: false
    },
    {
      Header: "Actions",
      id: "actions",
      filterable: false,
      Cell: renderUsersActions.bind(this, deleteUser, changePassword, canChangePassword),
      style: { textAlign: "center" }
    }
  ];
};
export const userModalDataColumns = (onChangeMethod, deleteVenue) => {
  return [
    {
      Header: "ITS",
      id: "its",
      accessor: "its",
      Cell: renderEditableInput.bind(this, "newUsers.$.", "its", true, onChangeMethod, "text"),
      style: { textAlign: "center" }
    },
    {
      Header: "Name",
      id: "name",
      accessor: "name",
      Cell: renderEditableInput.bind(this, "newUsers.$.", "name", true, onChangeMethod, "text"),
      style: { textAlign: "center" }
    },

    {
      Header: "Email",
      id: "email",
      accessor: "email",
      Cell: renderEditableInput.bind(this, "newUsers.$.", "email", true, onChangeMethod, "text"),
      style: { textAlign: "center" }
    },
    {
      Header: "Position",
      id: "position",
      accessor: "position",
      Cell: renderEditableInput.bind(this, "newUsers.$.", "position", true, onChangeMethod, "text"),
      style: { textAlign: "center" }
    },
    {
      Header: "Actions",
      id: "actions",
      filterable: false,
      Cell: renderNewUsersModalActions.bind(this, deleteVenue),
      style: { textAlign: "center" }
    }
  ];
};
